import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useEffect } from "react";
import MultipleAutocomplete from "../../shared/autoCompletes/MultipleAutocomplete";
import { FormatCNPJ, FormatCPF, FormatCellPhone } from "../../shared/format/Formats";
import AddressForm from "../../shared/address/AddressForm";
import CustomTextField from "../../shared/textFields/CustomTextField";
import FormatedCustomTextField from "../../shared/textFields/FormatedCustomTextField";
import CustomRadioGroup from "../CustomRadioGroup";
import CustomAutoComplete from "components/shared/autoCompletes/CustomAutoComplete";

export default function ClientForm({
  isCreation = true,
  totalWidth,
  columnHeight,
  apiData,
  isEngineer,
  willReceiveAutomaticCharges,
  isUniqueCharge,
  receiveChecklistNotifications,
  whereToSentCharges,
  isAutomaticChargesSelected,
  clientName,
  isDisabled,
  cellPhone,
  email,
  invoiceId,
  isActive,
  isChecked,
  powerDistributionCompanies,
  table,
  clientType,
  cpf,
  cnpj,
  addressController,
  areAddressFieldsDisabled,
  clearCnpj,
  clearCpf,
  removeChargeFieldsErrors,
  clearChargeFields,
  layout = "horizontal", // "horizontal" ou "vertical"
}) {
  useEffect(() => {
    if (!willReceiveAutomaticCharges.checked) {
      removeChargeFieldsErrors();
      clearChargeFields();
    }
  }, [willReceiveAutomaticCharges.checked]);

  useEffect(() => {
    if (clientType.value == "cpf") {
      clearCnpj();
    } else {
      clearCpf();
    }
  }, [clientType.value]);

  const isVertical = layout === "vertical";

  return (
    <Box
      sx={{
        width: totalWidth,
        display: "flex",
        flexDirection: isVertical ? "column" : "row",
        justifyContent: "space-between",
        mt: 2,
        gap: isVertical ? 2 : 0,
      }}
    >
      <Box
        sx={{
          width: isVertical ? "100%" : "45%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {isCreation ? (
          ""
        ) : (
          <FormControlLabel
            control={<Checkbox checked={isActive.checked} onChange={isActive.onChange} />}
            label="Está ativo?"
            labelPlacement="start"
            sx={{ marginLeft: 0 }}
          />
        )}
        <FormControlLabel
          control={<Checkbox checked={isEngineer.checked} onChange={isEngineer.onChange} />}
          label="É engenheiro?"
          labelPlacement="start"
          sx={{ marginLeft: 0 }}
        />

        <FormControlLabel
          control={<Checkbox checked={willReceiveAutomaticCharges.checked} onChange={willReceiveAutomaticCharges.onChange} />}
          label="Cobranças automáticas? (Boleto)"
          labelPlacement="start"
          sx={{ marginLeft: 0 }}
        />

        <FormControlLabel
          control={<Checkbox checked={isUniqueCharge.checked} onChange={isUniqueCharge.onChange} />}
          label="Boleto Integral"
          disabled={willReceiveAutomaticCharges.checked === false}
          labelPlacement="start"
          sx={{ marginLeft: 0 }}
        />

        <FormControlLabel
          control={<Checkbox checked={receiveChecklistNotifications.checked} onChange={receiveChecklistNotifications.onChange} />}
          label="Receber notificações de checklist pendente?"
          labelPlacement="start"
          sx={{ marginLeft: 0 }}
        />

        <CustomTextField
          params={clientName}
          disabled={isDisabled}
          label="Nome do Cliente"
          maxLength={30}
          width={totalWidth}
          required={true}
        />
        <FormatedCustomTextField
          params={cellPhone}
          disabled={isDisabled}
          label="Whatsapp"
          inputcomponent={FormatCellPhone}
          width={totalWidth}
          required={true}
        />
        <CustomTextField
          params={email}
          disabled={isDisabled}
          label="Email"
          width={totalWidth}
          required={true}
        />

        <MultipleAutocomplete
          width={totalWidth}
          required={true}
          label="Concessionárias"
          params={powerDistributionCompanies}
          values={apiData.powerDistributionCompanies}
          isChecked={isChecked}
        />

        <CustomTextField
          params={invoiceId}
          disabled={isCreation}
          label="ID de Nota Fiscal"
          width={totalWidth}
          required={false}
        />

        <CustomAutoComplete
          margin={0}
          pt={0}
          params={table}
          options={apiData.priceTables}
          disabled={false}
          label="Tabela de Preço"
          width="100%"
        />
      </Box>
      <Box
        sx={{
          width: isVertical ? "100%" : "45%",
          height: isVertical ? "auto" : columnHeight,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <CustomRadioGroup
          radioGroupParams={whereToSentCharges}
          label={"Modo de envio de cobranças:"}
          radioValues={["whatsapp", "email"]}
          radioLabels={["Whatsapp", "E-mail"]}
          disabled={isAutomaticChargesSelected}
        />
        <CustomRadioGroup
          radioGroupParams={clientType}
          label={"Tipo de cliente:"}
          radioValues={["cpf", "cnpj"]}
          radioLabels={["Pessoa Física", "Pessoa Jurídica"]}
          disabled={isAutomaticChargesSelected}
        />
        <Box
          display="flex"
          sx={{
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <FormatedCustomTextField
            params={cpf}
            disabled={isAutomaticChargesSelected || clientType.value == "cnpj"}
            label="CPF"
            inputcomponent={FormatCPF}
            required={true}
            width="48.5%"
          />
          <FormatedCustomTextField
            params={cnpj}
            disabled={isAutomaticChargesSelected || clientType.value == "cpf"}
            label="CNPJ"
            inputcomponent={FormatCNPJ}
            required={true}
            width="48.5%"
          />
        </Box>
        <AddressForm
          controller={addressController}
          areAddressFieldsDisabled={areAddressFieldsDisabled}
        />
      </Box>
    </Box>
  );
}
